<template>
    <div class="qw-chatbot" @keydown.esc="closeChatbot()" v-outer-click="handleOuterClick">
        <transition name="slide-fade">
            <qw-chat class="open" v-show="showChat"></qw-chat>
        </transition>
        <button class="toggle-chatbot" @click="toggleChatbot()"><i class="fas fa-comments"></i></button>
    </div>
</template>

<script>
import QwChat from "@/components/chatbot/QWChat";
export default {
    name: "qw-chatbot",
    components: {
        QwChat
    },
    methods: {
        openChatbot() {
            this.$store.commit("chatbot/openChatbot");
        },
        closeChatbot() {
            this.$store.commit("chatbot/closeChatbot");
        },
        toggleChatbot() {
            if(this.showChat)
                this.closeChatbot();
            else
                this.openChatbot();
        },
        handleOuterClick() {
            if(this.showChat)
                this.closeChatbot();
        }
    },
    computed: {
        showChat() {
            return this.$store.getters['chatbot/isChatbotOpen'];
        } 
    },
}
</script>

<style lang="scss" scoped>
.qw-chatbot {
    position: fixed;
    right: 20px;
    bottom: 15px;
    z-index: 9999; 
    @include fastestTransition;
    .toggle-chatbot {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        font-size: 23px;
        border-radius: 50%;
        border: none;
        background-color: $primary;
        color: $white;
        cursor: pointer;
        @include removeBootstrapOutline;
        @include fastestTransition;
        &:hover {
            background-color: darken($primary, 5%);
        }
    }
    &.tasks-open {
        margin-right: $tasks-sidebar-width;
    }
}

@media screen and (max-width: $breakpoint-sm) {
    .qw-chatbot {
        right: 10px;
        bottom: 10px;
        .toggle-chatbot {
            width: 40px;
            height: 40px;
            font-size: 18px;
        }
        &.tasks-open {
            margin-right: $tasks-sidebar-width-xs;
        }
    }
}

.dark {
    .qw-chatbot {
        .toggle-chatbot {
            background-color: $extra-darker-gray;
            color: $gray;
            &:hover {
                color: $primary;
            }
        }
    }
}
</style>